import { z } from 'zod';

export const dynamicPaywallPriceData = z.object({
  currencyCode: z.string(),
  productPrice: z.number(),
  productPriceString: z.string(),
  offerPrice: z.number(),
  offerPriceString: z.string(),
  discountPercent: z.number().optional(),
  productSecondPriceString: z.string(),
});

export type DynamicPaywallPriceData = z.infer<typeof dynamicPaywallPriceData>;
